var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFormsTraining = function SvgFormsTraining(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.406 7.898a1.264 1.264 0 00-1.169.049 1.124 1.124 0 00-.57.966v5.508a1.125 1.125 0 00.57.966 1.263 1.263 0 001.169.048l5.169-2.44a1.45 1.45 0 000-2.657l-5.17-2.44zM25.556 33.333H14.444l1.112-6.666h8.888l1.112 6.666zM11.111 33.333H28.89M3.333 21.111h33.334",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.333 2.222h33.334v24.445H3.333V2.222z",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFormsTraining;